import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Badge,
  Card,
  CardHeader,
  Table,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
} from "reactstrap";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Referrals = () => {
  const [users, setUsers] = useState([]);
  const [referrals, setReferrals] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [referralPercentage, setReferralPercentage] = useState(''); // Store the referral percentage
  const [modalOpen, setModalOpen] = useState(false); // Control modal visibility
  const [selectedReferral, setSelectedReferral] = useState(null);  // Holds the referral being edited
  const [updatedEarning, setUpdatedEarning] = useState('');  // Holds the new earning value
  
  // Handle the Edit button click
  const handleEditReferral = (referral) => {
    setSelectedReferral(referral);  // Set the referral being edited
    setUpdatedEarning(referral.earning);  // Pre-fill the updated earning value
    toggleModal();  // Open the modal
  };
  
  // Save the new earning value
const handleUpdateEarning = async () => {
  if (!selectedReferral) return;

  try {
    const token = localStorage.getItem('token');
    
    // Send the updated earning value to the backend
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/referrals/update`, {
      id: selectedReferral.id,
      earning: updatedEarning,
    }, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });

    if (response.status === 200) {
      toast.success("Referral earning updated successfully!");
      toggleModal(); // Close the modal
      fetchUsersAndReferrals(); // Refetch the data after update
    } else {
      toast.error("Failed to update referral earning.");
    }
  } catch (error) {
    console.error("Update error:", error);
    toast.error("Error updating referral earning.");
  }
};
  
  // Fetch users, referrals, and settings
const fetchUsersAndReferrals = async () => {
  try {
    const token = localStorage.getItem('token');
    const referralResponse = await axios.get(`${process.env.REACT_APP_API_URL}/referrals`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
    const referralData = referralResponse.data.referrals || [];
    console.log("Raw referral data:", referralData);

    const enhancedReferrals = referralData.map(referral => {
      return {
        id: referral._id,
        referrer_id: referral.referrer_id,
        referrerName: referral.referrer_id, // This might need adjustment based on actual structure
        referrerWallet: referral.referrer_wallet,
        referrerEmail: "", // Add if available in your data
        referred_id: referral.referred_user_id,
        referredUserName: referral.referred_user_id, // This might need adjustment
        referredUserWallet: referral.referred_wallet,
        referredUserEmail: "", // Add if available
        earning: parseFloat(referral.earning),
        claimed: referral.claimed,
        isApprove: referral.isApprove,
        createdAt: new Date(referral.createdAt).toLocaleDateString(),
      };
    });

    console.log("Enhanced referrals:", enhancedReferrals);
    setReferrals(enhancedReferrals);
  } catch (error) {
    console.error("Error fetching referrals:", error.message);
  }
};

  useEffect(() => {
    fetchUsersAndReferrals();
  }, []);

  // Open modal to edit referral percentage
  const toggleModal = () => setModalOpen(!modalOpen);

  // Save the edited referral percentage
  const handleSave = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/settings/update`, {
        setting_key: 'referral_percentage',
        setting_value: referralPercentage,
      });

      if (response.status === 200) {
        toast.success("Referral percentage updated successfully!");
        toggleModal(); // Close the modal
        fetchUsersAndReferrals(); // Refetch the data after update
      } else {
        toast.error("Failed to update referral percentage.");
      }
    } catch (error) {
      toast.error("Error updating referral percentage.");
    }
  };

  return (
    <div className="container" style={{ paddingTop: '100px', maxWidth: "100%" }}>
      <Row style={{ backgroundColor: "rgba(1,1,1,0.2)" }}>
        <div className="col">
          <Card style={{ backgroundColor: "transparent" }}>
            <div style={{ marginBottom: "20px" }}>
            <Row className="align-items-center">
      <Col xs={12} md={12} className="mb-3 mb-md-0">
        <Input
          type="text"
          value={searchQuery}
          style={{
            background: 'black',
            border: 'none',
            outline: 'none',
            padding: '15px',  // Reduced padding for better responsiveness
            fontSize: '16px',
            width: '100%',  // Ensure input takes full width within its container
          }}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search by wallet Address"
        />
      </Col>
      {/* <Col xs={12} md={3} className="d-flex align-items-center justify-content-md-start justify-content-center">
        <Button
          style={{
            fontSize: '14px',
            padding: '10px 15px',  // Adjusted padding for responsiveness
            width: '100%',  // Ensure the button takes full width on smaller screens
          }}
          color="primary"
          onClick={toggleModal}
        >
          Edit Referral Commission
        </Button>
      </Col> */}
    </Row>
            </div>

            <CardHeader className="border-0" style={{ backgroundColor: "rgba(1,1,1,0.2)", border: "none" }}>
              <h3 className="mb-0" style={{ color: "white", fontSize: "40px", fontWeight: "bolder" }}>
                Top Referral Lists
              </h3>
            </CardHeader>
            <Table responsive>
              <thead>
                <tr>
                  <th style={{ color: "white", padding: "10px", border:'none', backgroundColor: "rgba(1,1,1,0.2)" }}>Referrer</th>
                  <th style={{ color: "white", padding: "10px", border:'none', backgroundColor: "rgba(1,1,1,0.2)" }}>Referred User</th>
                  <th style={{ color: "white", padding: "10px", border:'none', backgroundColor: "rgba(1,1,1,0.2)" }}>Earning</th>
                  <th style={{ color: "white", padding: "10px", border:'none', backgroundColor: "rgba(1,1,1,0.2)" }}>Status</th>
                  <th style={{ color: "white", padding: "10px", border:'none', backgroundColor: "rgba(1,1,1,0.2)" }}>Date</th>
                  <th style={{ color: "white", padding: "10px", border:'none', backgroundColor: "rgba(1,1,1,0.2)" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {referrals
                  .filter((referral) => {
                    const lowercasedQuery = searchQuery.toLowerCase();
                    return (
                      referral.referrerWallet.toLowerCase().includes(lowercasedQuery) ||
                      referral.referredUserWallet.toLowerCase().includes(lowercasedQuery)
                    );
                  })
                  .sort((a, b) => b.earning - a.earning)
                  .map((referral) => (
                    <tr key={referral.id}>
                      <td style={{color:'white', border:"none"}}>
                        <div>{referral.referrerName}</div>
                        <small>{referral.referrerWallet}</small>
                      </td>
                      <td style={{color:'white', border:"none"}}>
                        <div>{referral.referredUserName}</div>
                        <small>{referral.referredUserWallet}</small>
                      </td>
                      <td style={{color:'white', border:"none"}}>{referral.earning.toFixed(2)}</td>
                      <td style={{color:'white', border:"none"}}>
                        {referral.claimed ? 'Claimed' : 'Pending'}
                      </td>
                      <td style={{color:'white', border:"none"}}>{referral.createdAt}</td>
                      <td style={{color:'white', border:"none"}}>
                        <Button color="warning" size="sm" onClick={() => handleEditReferral(referral)}>
                          Edit
                        </Button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Card>
        </div>
      </Row>

      {/* Modal for editing referral percentage */}
      {/* <Modal isOpen={modalOpen} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Edit Referral Commission</ModalHeader>
        <ModalBody>
          <div>
            <label htmlFor="referralPercentage" style={{color:'black'}}>Referral Percentage:</label>
            <Input
              type="number"
              id="referralPercentage"
              value={referralPercentage}
              onChange={(e) => setReferralPercentage(e.target.value)}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSave}>Save</Button>
          <Button color="secondary" onClick={toggleModal}>Cancel</Button>
        </ModalFooter>
      </Modal> */}

      {/* Add this Modal for editing referral earnings */}
    <Modal isOpen={modalOpen} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}>Edit Referral Earning</ModalHeader>
      <ModalBody>
        <div>
          <label htmlFor="updatedEarning" style={{color:'black'}}>Earning Amount:</label>
          <Input
            type="number"
            id="updatedEarning"
            value={updatedEarning}
            onChange={(e) => setUpdatedEarning(e.target.value)}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleUpdateEarning}>Save</Button>
        <Button color="secondary" onClick={toggleModal}>Cancel</Button>
      </ModalFooter>
    </Modal>

    <ToastContainer position="top-center" />
  </div>)
};

export default Referrals;
